module.exports = __webpack_public_path__ + "img/life-at-ommax-3.f055f4be.jpg";